<template>
  <div>
    <Header :sidebar-active.sync="sidebarActive" @logout-click="onLogout" />

    <media :query="{ maxWidth: screens.md }">
      <Sidebar :active="sidebarActive">
        <nav class="sidebar-nav">
          <router-link is="Button" class="nav-link" to="/templates">
            <div class="nav-link-icon-wrap">
              <v-icon
                slot="icon-start"
                name="palette"
                scale=".7"
                class="nav-link-icon mr-1"
              />
            </div>
            Templates
          </router-link>

          <router-link is="Button" class="nav-link" to="/campaigns">
            <div class="nav-link-icon-wrap">
              <v-icon
                slot="icon-start"
                name="list"
                scale=".7"
                class="nav-link-icon mr-1"
              />
            </div>
            Campaigns
          </router-link>

          <Button
            class="meta-link"
            href="http://help.promo.ai/category/newsletters-by-promo-ai/"
            target="_blank"
            @click="sidebarActive = false"
          >
            <div class="nav-link-icon-wrap">
              <v-icon
                slot="icon-start"
                name="question"
                scale=".7"
                class="nav-link-icon mr-1"
              />
            </div>

            Help
          </Button>

          <router-link is="Button" class="meta-link" to="/plans">
            <div class="nav-link-icon-wrap">
              <v-icon
                slot="icon-start"
                name="regular/credit-card"
                scale=".7"
                class="nav-link-icon mr-1"
              />
            </div>

            Change Plan
          </router-link>

          <Button class="meta-link" @click="onLogout">
            <div class="nav-link-icon-wrap">
              <v-icon
                slot="icon-start"
                name="sign-out-alt"
                class="nav-link-icon mr-1"
                scale=".8"
              />
            </div>

            Logout
          </Button>
        </nav>
      </Sidebar>
    </media>

    <Banner
      v-if="alertTitle || alertMessage"
      icon="exclamation-circle"
      type="info"
      :title="alertTitle"
      :message="alertMessage"
      class="m-4 md:m-6 lg:mx-auto lg:my-8"
    />

    <slot />
  </div>
</template>

<script>
import Media from "vue-media";
import Header from "@/components/Header.vue";
import Sidebar from "@/components/UI/Sidebar/Sidebar";

import Banner from "@/components/UI/Banner/Banner";
import { unauthenticate } from "@/lib/auth";
import { getAccountId } from "@/lib/auth";

export default {
  name: "DefaultLayout",
  inject: ["screens"],
  components: { Banner, Header, Media, Sidebar },
  data() {
    return {
      sidebarActive: false,
    };
  },
  computed: {
    alertTitle() {
      return this.$route?.query?.alertTitle;
    },
    alertMessage() {
      return this.$route?.query?.alertMessage;
    },
  },
  watch: {
    $route(to, from) {
      this.sidebarActive = false;
    },
  },
  methods: {
    onLogout: async function() {
      this.sidebarActive = false;
      unauthenticate(this.$apollo.provider.defaultClient);
    },
  },
};
</script>

<style scoped>
>>> .sidebar {
  @apply bg-brand-light;
}

.nav-link {
  @apply w-full text-base text-support-light p-4 no-underline border-b rounded-none;
  border-color: #e6e6e6;

  &:hover,
  &:focus {
    @apply text-brand;
  }
}

.nav-link-icon-wrap {
  @apply text-center;
  width: 34px;
}

.nav-link-icon {
  @apply text-support-lightest;
}

.meta-link {
  @apply nav-link font-normal font-sans text-sm py-2;
}
</style>
